import {Component, Input, OnInit} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {ModalController} from "@ionic/angular";
import {Invoice} from "../../models/invoice.model";

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.scss'],
})
export class InvoiceDetailsComponent implements OnInit {

  @Input() invoice: Invoice;
  @Input() invoices: Invoice[];
  @Input() title;

  constructor(public commonUtils: CommonUtils,
              private modalController: ModalController) {
  }

  ngOnInit() {
  }

  onClose() {
    this.modalController.dismiss();
  }

  copyValue(str: any){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = str.toString();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();

    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (str));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });

    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.commonUtils.presentSimpleInfoToast('JSON faktury skopiowana do schowka', 'bottom', 2000);
  }

  getJson(i: any) {
   return JSON.stringify(i)
  }
}




